import { LAYOUTS } from "@voltmoney/types";
import SharedPropsService from "../../../SharedPropsService";
import { ROUTE } from "../../../routes";
import { WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { Platform } from 'react-native';
import { goBack, leadToPayment, leadToPaymentPage, leadToPaymentWeb, navigateToRecomendedScreen, navigateToTransaction, needHelp, resetPage } from "./action";
import { showNewRepaymentFlowDc } from "../../../configs/utils";
export const template = (height, currentLender, shortfallDetails, isFromDsp, showNewRepaymentFlow) => ({
    layout: {
        id: ROUTE.SHORTFALL_REPAY_SCREEN,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: "shortfallRepay",
                type: WIDGET.SHORTFALL_REPAY,
            },
        ],
    },
    datastore: {
        shortfallRepay: {
            height,
            currentLender,
            shortfallDetails,
            backAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.SHORTFALL_REPAY_SCREEN,
                payload: { isFromDsp: isFromDsp }
            },
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.SHORTFALL_REPAY_SCREEN,
                payload: {}
            },
            shortfallRepayment: {
                type: showNewRepaymentFlow ? ACTION.LEAD_TO_SHORTFALL_PAYMENT : Platform.OS === 'web' ? ACTION.SHORTFALL_WEB_REPAYMENT : ACTION.SHORTFALL_REPAYMENT,
                routeId: ROUTE.SHORTFALL_REPAY_SCREEN,
                payload: {}
            },
            navigateToShortfallRecomendedScreen: {
                type: ACTION.SHORTFALL_RECOMENDED,
                routeId: ROUTE.SHORTFALL_REPAY_SCREEN,
                payload: { shortfallDetails }
            },
            navigateToTransaction: {
                type: ACTION.NAVIGATE_TRANSACTION,
                routeId: ROUTE.SHORTFALL_REPAY_SCREEN,
                payload: {}
            }
        },
    },
});
export const shortfallRepayScreenMF = {
    onLoad: async ({ instrumentTrack, getHeight }, { shortfallDetails, isFromDsp }) => {
        const user = await SharedPropsService.getUser();
        const currentLender = user?.linkedCredits[0]?.lendingPartnerId;
        const showNewRepaymentFlow = await showNewRepaymentFlowDc();
        return Promise.resolve(template(getHeight(), currentLender, shortfallDetails, isFromDsp, showNewRepaymentFlow));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.SHORTFALL_RECOMENDED]: navigateToRecomendedScreen,
        [ACTION.SHORTFALL_REPAYMENT]: leadToPayment,
        [ACTION.SHORTFALL_WEB_REPAYMENT]: leadToPaymentWeb,
        [ACTION.NAVIGATE_TRANSACTION]: navigateToTransaction,
        [ACTION.CANCEL_ACTION]: resetPage,
        [ACTION.LEAD_TO_SHORTFALL_PAYMENT]: leadToPaymentPage,
    },
};
